<template>
  <svg
    id="minds_icon"
    version="1.1"
    class="social-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 560 560"
    :width="width"
    xml:space="preserve">
    <path
      :fill="color"
      d="M374.1,145.4c-10-16.4-24.3-29.8-41.4-38.9c-16.2-8.7-34.7-13.2-53.2
      -13.2c-30.1,0-58.1,11.7-78.6,33c-22.1,22.9-33.5,55.3-30.5,86.8c1.6,16.5,
      7.2,30.1,13.9,44.9l27,59.8c1,2.2,2,4.4,3,6.7c1.9,4.4,3.9,9,6.1,13.5c0,
      2.1,0,4.3,0,6.4c0,1.4,0,2.8,0,4.2c0,7.4,5.6,12.9,13.1,12.9s13.1-5.6,13.1
      -12.9c0-11.2-0.9-18.1-5.9-29.3l-20.8-46c-2-4.4-4-8.8-6-13.1c-3.9-8.5-8
      -17.4-11.7-26.1c-7.9-18.4-8.2-40.5-0.8-60.5c12-32.6,43.1-53.7,79.3
      -53.7c28.1,0,53.1,12.9,68.6,35.5c15.2,22.1,19.1,52,9.9,76c-2.4,6.4-5.5,
      12.8-8.5,19.1c-1.5,3.2-3.1,6.5-4.6,9.8l-24.6,54.4c-0.6,1.4-1.3,2.9-2.1,
      4.4c-1.6,3.3-3.3,6.7-4.5,10.3c-1.8,5.4-1.7,10.8-1.5,15.6c0,1.3,0.1,2.5,
      0.1,3.7c0,7.4,5.6,12.9,13.1,12.9l0,0c3.3,0,6.4-1.1,8.7-3.2c2.8-2.4,4.4
      -5.9,4.4-9.8c0-0.9,0.1-2,0.1-3.1c0.1-2.4,0.3-5-0.1-7.8c1.3-3,2.7-6,
      4-8.9c0.8-1.8,1.7-3.6,2.5-5.4l24-53.3c1.4-3,2.8-6,4.3-9.1c4.1-8.5,
      8.3-17.3,11.1-26.7C394.4,204.7,390.1,171.5,374.1,145.4z" />
    <polygon
      :fill="color"
      points="327.4,414.6 322.6,409.7 322.6,400 327.4,395.1 327.4,
      380.5 232.6,380.5 232.6,395.1 237.5,400
      237.5,409.7 232.6,414.6 237.5,419.5 237.5,429.2 232.6,
      434.1 237.5,438.9 237.5,453 244.4,459.9 244.4,466.8 315.7,466.8
      315.7,459.9 322.6,453 322.6,438.9 327.4,434.1 322.6,429.2 322.6,
      419.5" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 40,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
